// extracted by mini-css-extract-plugin
module.exports = {"discoverBoard":"DiscoverBoard_discoverBoard__3ARpJ","footer":"DiscoverBoard_footer__ubKue","addButton":"DiscoverBoard_addButton__315SA"};